import React from 'react'
import { styled } from '../../stitches/stitches.config'
import Spacer from '../base/Spacer'
import FullSizeInput from '../base/FullSizeInput'
import FloatingFooter from '../common/FloatingFooter'

type Props = {
  onIdentify: (groupCode: string) => void
  hasError: boolean
}

type FormValues = {
  groupCode: string
}

const PageMainIdentify: React.FC<Props> = ({ onIdentify, hasError }) => {
  const formRef = React.useRef<HTMLFormElement>(null)

  const handleClick = (e: React.FormEvent<HTMLFormElement>) => {
    const data = new FormData(e.currentTarget)
    const values = Object.fromEntries(data.entries()) as FormValues
    onIdentify(values.groupCode)
    e.preventDefault()
  }

  return (
    <Container ref={formRef} onSubmit={handleClick}>
      <Title>{'전달받은 인증번호를\n입력해주세요.'}</Title>
      <Spacer h={18} />
      <FullSizeInput name="groupCode" type="text" placeholder="CODE" />
      {hasError && (
        <ErrorMessage>
          <b>인증번호</b>가 올바른지 확인해주세요.
        </ErrorMessage>
      )}
      <FloatingFooter>
        <Button type="submit">인증하기</Button>
      </FloatingFooter>
    </Container>
  )
}

export default PageMainIdentify

const Container = styled('form', {
  position: 'relative',
  flex: 1,
  padding: '12px 16px',
  overflow: 'hidden',
})

const Title = styled('div', {
  $text: 'title',
  color: 'white',
  whiteSpace: 'pre-wrap',
})

const ErrorMessage = styled('div', {
  margin: '12px 0 0',
  color: 'white',
  $text: 'label',
})

const Button = styled('button', {
  borderRadius: '6px',
  width: '100%',
  padding: '12px 0',
  $text: 'title',
  background: 'white',
  color: '$gray900',
  transitionDuration: '0.4s',
  userSelect: 'none',

  '&:active': {
    background: '$gray100',
    boxShadow: '0 5px 10px 0 rgba(0,0,0,0.2)',
    transform: 'translateY(4px)',
    outline: 'none',
    WebkitTabHighlightColor: 'transparent',
  },
})
